"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUnit = exports.getUnit = exports.setUnit = void 0;

var corona_1 = require("corona");

var unit_1 = require("../types/unit");

function setUnit(unit) {
  return {
    type: unit_1.SET_UNIT,
    unit: unit
  };
}

exports.setUnit = setUnit;

function getUnit(uuid) {
  return function (dispatch, getState) {
    var unit = new corona_1.Unit(new corona_1.UUID(uuid));
    var fields = [corona_1.Field.Location, corona_1.Field.Meter, corona_1.Field.Modem, corona_1.Field.Connections, corona_1.Field.Ports, corona_1.Field.Fields, corona_1.Field.Scheduling, corona_1.Field.SLA, corona_1.Field.WorkOrders];
    return unit.get(fields, getState().authentication).then(function (unit) {
      dispatch(setUnit(unit));
    });
  };
}

exports.getUnit = getUnit;

function loadUnit(uuid) {
  return function (dispatch, getState) {
    var unit = new corona_1.Unit(new corona_1.UUID(uuid));
    unit.load();
    dispatch(setUnit(unit));
  };
}

exports.loadUnit = loadUnit;